export const defaultHistoryFrequencyFilter = { code: "180", text: "6 months" };
